import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { usePairsStore } from '@/stores/usePairsStore'
import { getCoinIcon } from '@/lib/common'
import { CommonFooter } from '@/components/layout'
import noDataImg from '@/assets/images/noData.svg'

export function TradeMiningPage() {
  const { t } = useTranslation()
  const { pairs } = usePairsStore()

  const minePairs = useMemo(() => pairs.filter((p) => p.mineWeight > 0), [pairs])

  return (
    <div className="w-full flex justify-center px-4 md:px-[32px] md:mt-[32px]">
      <div className="w-full max-w-[600px]">
        <div className="bg-white rounded-[26px] shadow-[0_0_8px_1px_rgba(61,98,50,0.14)] px-[16px] py-[24px]">
          <h3 className="text-[16px] font-bold text-foreground mb-[16px]">{t('nav.tradeMining')}</h3>

          {minePairs.length === 0 ? (
            <div className="flex flex-col items-center py-[30px]">
              <img src={noDataImg} className="w-[120px] mb-[12px]" alt="" />
              <span className="text-[14px] text-[#999]">{t('public.noData')}</span>
            </div>
          ) : (
            <div className="space-y-[12px]">
              {minePairs.map((pair) => (
                <div key={pair.id} className="flex items-center justify-between p-[12px] rounded-[16px] border border-[#e5e5e5]">
                  <div className="flex items-center gap-[8px]">
                    <div className="flex -space-x-2">
                      <img src={getCoinIcon(pair.token0.contract, pair.token0.coin)} className="w-[28px] h-[28px] rounded-full bg-gray-100 border-2 border-white" alt="" />
                      <img src={getCoinIcon(pair.token1.contract, pair.token1.coin)} className="w-[28px] h-[28px] rounded-full bg-gray-100 border-2 border-white" alt="" />
                    </div>
                    <span className="text-[14px] font-semibold text-foreground">
                      {pair.token0.coin}/{pair.token1.coin}
                    </span>
                  </div>
                  <div className="text-right text-[13px]">
                    <div className="text-[#666]">Weight: <span className="text-foreground font-semibold">{pair.mineWeight}</span></div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <CommonFooter />
      </div>
    </div>
  )
}
